import React from "react";
import Typed from "typed.js";
import Myphoto from "../Images/Myphoto.png";
import vector from "../Images/Vector.png";
import vector1 from "../Images/Vector (1).png";
import hi from "../Images/hi.png";
import { Link } from "react-scroll";
import resume from "../Components/files/Resume.pdf";
import avatar from "../Images/avatar.png";
import ml from "../Images/Skills/ML.png";
import game from "../Images/Skills/Game.png";
import webd from "../Images/Skills/WebD.png";
import figma from "../Images/Skills/Figma.png";

export default function Home() {
  const el = React.useRef(null);
  const ell = React.useRef(null);

  React.useEffect(() => {
    const typed = new Typed(el.current, {
      strings: [
        "Full Stack Web developer",
        "Database Developer",
        "Python Coder",
        "C++ Coder",
        "Game Developer",
      ],
      typeSpeed: 40,
      loop: true,
      loopCount: Infinity,
      showCursor: false,
    });
    const type = new Typed(ell.current, {
      strings: [
        "I am a third year student at Delhi Technological University.",
        "I am pursuing B.Tech in Information Technology at DTU.",
        "I was born and raised up in Ballia, U.P.",
        "I completed my High School from Aditya Birla Public School, Renukoot, Sonebhadra with 96.6%.",
        "I completed my Senior Secondary School from LB Shastri Smarak JAVM Sr Sec School, RK Puram, Delhi with 95.6%.",
      ],
      typeSpeed: 30,
      loop: true,
      loopCount: Infinity,
      showCursor: false,
    });

    return () => {
      // Destroy Typed instance during cleanup to stop animation
      typed.destroy();
      type.destroy();
    };
  }, []);
  return (
    <div>
      <div className="flex justify-between bg-black text-white w-full px-6">
        <span className="flex">
          <img
            src={avatar}
            alt="avatar"
            className="w-20 border-2 rounded-full"
          />
          <h1 className="text-lg pl-4 pt-6">MyPortFolio</h1>
        </span>
        <ul className="flex px-4 py-6 space-x-4 text-lg">
          <li className="cursor-pointer hover:border-2 hover:rounded-xl px-4 hover:bg-white hover:text-black">
          <Link
          to="home" spy={true} smooth={true} offset={0} duration={500}
          >
          Home</Link>
          </li>
          <li className="cursor-pointer hover:border-2 hover:rounded-xl px-4 hover:bg-white hover:text-black">
            <Link
            to="about" spy={true} smooth={true} offset={0} duration={500}
            >
            About Me</Link>
          </li>
          <li className="cursor-pointer hover:border-2 hover:rounded-xl px-4 hover:bg-white hover:text-black">
          <Link
          to="skills" spy={true} smooth={true} offset={0} duration={500}
          >
          My Skills</Link>
          </li>
        </ul>
        <button className="cursor-pointer border-2 rounded-xl px-4 my-6 border-white hover:bg-white hover:text-black">
          <Link to={resume} target="_blank" download="HarshTiwari resume.pdf">
            My Resume
          </Link>
        </button>
      </div>
      <div id="home">
        <div className="w-full h-screen bg-black text-white overscroll-y-hidden">
          <img
            src={Myphoto}
            className="w-[30%] absolute z-10 border-2 rounded-full border-dotted right-10 bottom-[20%]"
            alt="Myphoto"
          />
          <img
            src={vector}
            className="bottom-[-390px] absolute z-20"
            alt="vector"
          />
        </div>
        <span className="absolute z-30 text-white top-[30%] left-[20%] text-5xl">
          Hi I am Harsh <br /> And I am a{" "}
        </span>
        <span
          className="absolute z-30 text-white top-[42%] left-[20%] text-5xl"
          ref={el}
        />
      </div>
      <div
        className="w-full h-screen bg-black text-white overscroll-y-hidden relative z-30 grid-cols-3 gap-1"
        id="about"
      >
      <h1 className='cursor-pointer p-4'><Link to="home" spy={true} smooth={true} offset={-100} duration={500}>Go to Top</Link></h1>
        <div className="flex">
          <div className="text-justify w-1/2">
            <h1 className="ml-40 mt-40  text-[50px] pt-12 animate-bounce">
              Hi There!
            </h1>
            <span
              className="absolute z-30 text-white ml-40 text-3xl w-1/2"
              ref={ell}
            />
          </div>
          <div className="w-1/2">
            <img
              src={hi}
              alt="hi.png"
              className="w-96 mt-40 border-2 rounded-full border-dotted m-auto "
            />
          </div>
        </div>
        <img src={vector1} alt="vector" className="absolute z-40" />
      </div>
      <div
        className="w-full bg-black text-white overscroll-y-hidden relative p-10 z-30 m-auto pb-20"
        id="skills"
      >
      <h1 className='cursor-pointer p-4'><Link to="home" spy={true} smooth={true} offset={-100} duration={500}>Go to Top</Link></h1>
      <h1 className="text-center text-3xl font-semibold animate-bounce mb-8">My Skills</h1>
        <div className="grid grid-cols-2 gap-24 p-auto m-auto">
          <div className="m-auto flex-col border-2 rounded-md border-white">
            <div className="">
              <img src={ml} alt="skill" className=" w-[560px] p-2" />
            </div>
            <h1 className="text-md text-center border-2">
              Library Management With Facial recognition and Text-to-Speech
              Funcationality
            </h1>
            <h1 className="w-[560px] text-center">
              Console-Based application | Python, ML (libraries), PyCharm
              Professional, MySQL, pyttxl 3
            </h1>
            <hr />
            <h1 className="w-[560px] p-2 text-justify">
              Allows for a 5-second reaction time at all times a user logs in
              using facial recognition.
              <br />
              Takes advantage of QR codes in order to issue or return plenty of
              books 1 at a time.
              <br />
              More than one individual may login, however preference has been
              assigned as First Come First Serve.
            </h1>
          </div>
          <div className="m-auto flex-col border-2 rounded-md border-white">
            <div className="">
              <img src={figma} alt="skill" className="w-[560px] p-2" />
            </div>
            <h1 className="text-md text-center border-2">
              Design for a self checkout app for library
            </h1>
            <h1 className="w-[560px] text-center">
              Figma file | design for self-checkout application consisting of various interfaces for user to meddle with.
            </h1><hr />
            <h1 className="w-[560px] p-2 text-justify">
              Allows user to login usign google account and identifies user using the google account details.
              <br />
              Lets them borrow a nummber of books using qr-code and phones camera and also keeps a track of the books issued.
              <br />
              Keeps a track of fine, if any and allows online payment and generates a reciept.
            </h1>
          </div>
          <div className="m-auto flex-col border-2 rounded-md border-white">
            <div className="">
              <img src={webd} alt="skill" className="w-[560px] p-2" />
            </div>
            <h1 className="text-md text-center border-2">
              A website for esummit based on ReactJS an tailwind css
            </h1>
            <h1 className="w-[560px] text-center">
              WebSite | HTML 5, Tailwind (CSS library), ReactJs, React-dom, React-router and various other dependencies
            </h1><hr />
            <h1 className="w-[560px] p-2 text-justify">
              An interactive website competely based on ReactJs and tailwind css about the need of taking actions to safegaurd our environment.
              <br />
              Built for spreading awareness about our environment and helping people realise the need to save our environment by adapting eco-friendly actions and steps.
              <br />
              Allows the user to contact using a mail to option after filling a contact form contaning their query.
            </h1>
          </div>
          <div className="m-auto flex-col border-2 rounded-md border-white">
            <div className="">
              <img src={game} alt="skill" className="w-[560px] p-2" />
            </div>
            <h1 className="text-md text-center border-2">
              A Warehouse Wreckage game built using Unreal Engine and Blueprint
              functions
            </h1>
            <h1 className="w-[560px] text-center">
              An Executable Game built specifically to be played on Windows | Unreal Engine, Blueprints
            </h1>
            <hr />
            <h1 className="w-[560px] p-2 text-justify">
              A 3D game created using Unreal Engine and Blueprint with enabled
              physics.
              <br />
              A game similar to bottle shooter that allows players to launch a
              set number of balls (20) in an effort to topple some cans that
              have been put in a warehouse.
              <br />
              Resets once all the balls have been utilized with a reset time of
              2 seconds while employing built-in and custom functions to
              regulate the game's progression.
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
}
